import { render, staticRenderFns } from "./SlideResumeSection.vue?vue&type=template&id=0affaa8a&"
import script from "./SlideResumeSection.vue?vue&type=script&lang=js&"
export * from "./SlideResumeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports